export default __webpack_public_path__ + "static/vide-in-retail-c67b831db3b25069160516e4badf9bff.jpg";